$(document).ready(function() {
    $('.footer-cart-variation-select').on('change', function() {
        $('.product-short-info__image-wrapper picture img').attr('srcset', $(this).find('option:selected').data('image'));
        
        let variant = $(this).find('option:selected').data('option1');

        $('.product-swatch__item-input').each(function() {
            if ($(this).data('value') == variant) {
                $(this).prop('checked', true);
            }
        });

    });
});